module.exports = ".approvals-filtro{\n    display: -webkit-box;\n    margin-bottom: 20px;\n    text-align: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/reports/cost-by-project-report/cost-by-project-report.component.css
// module id = ./src/app/views/reports/cost-by-project-report/cost-by-project-report.component.css
// module chunks = main